import { Link } from "react-router-dom";
import lifactorLogo from "@/assets/lifactor-logo.png";
import { ReactNode } from "react";

interface ReportFooterProps {
  languageSwitcher?: ReactNode;
}

export const ReportFooter = ({ languageSwitcher }: ReportFooterProps = {}) => {
  return (
    <footer className="bg-background border-t border-border/40 py-8 mt-12 w-full">
      <div className="container max-w-5xl mx-auto px-4 sm:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center">
            <a 
              href="https://www.lifactor.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
            >
              <img 
                src={lifactorLogo} 
                alt="LiFactor" 
                className="h-10 w-auto object-contain"
              />
            </a>
          </div>
          
          <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-4 text-sm text-muted-foreground text-center">
            <Link 
              to="/polityka-prywatnosci" 
              className="hover:text-foreground transition-colors whitespace-nowrap"
            >
              Polityka prywatności
            </Link>
            <span className="hidden sm:inline text-border">|</span>
            <Link 
              to="/regulamin" 
              className="hover:text-foreground transition-colors whitespace-nowrap"
            >
              Regulamin
            </Link>
            <span className="hidden sm:inline text-border">|</span>
            <Link 
              to="/polityka-cookies" 
              className="hover:text-foreground transition-colors whitespace-nowrap"
            >
              Polityka plików cookie
            </Link>
            {languageSwitcher && (
              <>
                <span className="hidden sm:inline text-border">|</span>
                {languageSwitcher}
              </>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};
